import { MessageSquare } from "lucide-react";
import { Card } from "@/components/ui/card";

interface TemplatePreviewProps {
  headerType?: string;
  headerText?: string;
  bodyText: string;
  footerText?: string;
  buttons?: any[];
  exampleValues?: string[];
}

export function TemplatePreview({
  headerType,
  headerText,
  bodyText,
  footerText,
  buttons,
  exampleValues = [],
}: TemplatePreviewProps) {
  // Replace variables {{1}}, {{2}}, etc with example values
  const renderTextWithVariables = (text: string) => {
    if (!text) return '';
    
    let result = text;
    exampleValues.forEach((value, index) => {
      if (value) { // Only replace if value exists
        const placeholder = `{{${index + 1}}}`;
        result = result.replace(new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g'), value);
      }
    });
    return result;
  };

  return (
    <Card className="p-4 bg-background border-border max-w-sm">
      <div className="flex items-start gap-2 mb-3">
        <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
          <MessageSquare className="w-4 h-4 text-primary" />
        </div>
        <div className="flex-1 space-y-2">
          {/* Header */}
          {headerType === 'TEXT' && headerText && (
            <div className="font-semibold text-foreground">
              {renderTextWithVariables(headerText)}
            </div>
          )}
          
          {headerType === 'IMAGE' && (
            <div className="w-full h-32 bg-muted rounded flex items-center justify-center">
              <span className="text-sm text-muted-foreground">Image</span>
            </div>
          )}
          
          {headerType === 'VIDEO' && (
            <div className="w-full h-32 bg-muted rounded flex items-center justify-center">
              <span className="text-sm text-muted-foreground">Video</span>
            </div>
          )}
          
          {headerType === 'DOCUMENT' && (
            <div className="w-full h-20 bg-muted rounded flex items-center justify-center">
              <span className="text-sm text-muted-foreground">Document</span>
            </div>
          )}

          {/* Body */}
          <div className="text-sm text-foreground whitespace-pre-wrap">
            {renderTextWithVariables(bodyText) || (
              <span className="text-muted-foreground">This template has no body.</span>
            )}
          </div>

          {/* Footer */}
          {footerText && (
            <div className="text-xs text-muted-foreground">
              {footerText}
            </div>
          )}

          {/* Buttons */}
          {buttons && buttons.length > 0 && (
            <div className="space-y-1 pt-2 border-t border-border">
              {buttons.map((button, index) => (
                <button
                  key={index}
                  className="w-full text-center text-sm text-primary hover:bg-primary/10 py-1.5 rounded transition-colors"
                >
                  {button.text}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}
